import { html } from 'lit';
import { DropdownDialog } from '../dropdown-dialog/element';
import { dropDownDialogStyles } from '../dropdown-dialog/syles';
import { dropDownStyles } from './syles';
export class Dropdown extends DropdownDialog {
    constructor() {
        super(...arguments);
        this.slotChange = () => {
            this.slotBodyItems = this.slotBody.assignedElements();
            this.slotBodyItems.forEach((item) => {
                item.addEventListener('click', this.clickItem);
            });
        };
        this.clickItem = (e) => {
            e.stopImmediatePropagation();
            e.stopPropagation();
            this.handleSelectItem(e.target);
        };
        this.handleKeyDown = (e) => {
            if (this.hasAttribute('disabled')) {
                return;
            }
            switch (e.key) {
                case ' ':
                    this.focused ? this.handleSelectByKey() : this.clickHeader();
                    this.focused = !this.focused;
                    break;
                case 'ArrowDown':
                    this.focused && this.handleKeyArrowDown();
                    break;
                case 'ArrowUp':
                    this.focused && this.handleKeyArrowUp();
                    break;
                case 'Escape':
                case 'Tab':
                    this.focused && this.closeWithClick();
                    this.focused = false;
                    break;
                case 'Enter':
                    this.focused && this.handleSelectByKey();
                    this.focused = false;
                    break;
            }
        };
        this.handleSelectItem = (item) => {
            this.closeWithClick();
            this.value = item.innerText;
            this.dispatchEvent(new CustomEvent('clickedDropdownItem', {
                bubbles: true,
                composed: true,
                detail: item
            }));
        };
        this.handleKeyArrowDown = () => {
            this.focusIndex++;
            if (this.focusIndex >= this.slotBodyItems.length) {
                this.focusIndex = 0;
            }
            this.setSlotBodyItemsFocus(this.focusIndex);
        };
        this.handleKeyArrowUp = () => {
            this.focusIndex--;
            if (this.focusIndex < 0) {
                this.focusIndex = this.slotBodyItems.length - 1;
            }
            this.setSlotBodyItemsFocus(this.focusIndex);
        };
        this.handleSelectByKey = () => {
            const item = this.slotBodyItems[this.focusIndex];
            item ? this.handleSelectItem(item) : this.closeWithClick();
        };
        this.setSlotBodyItemsFocus = (focusIndex) => {
            this.slotBodyItems.forEach((item, index) => {
                item.classList.toggle('focused', index === focusIndex);
            });
        };
    }
    render() {
        return html `
            <div class="header" @click="${this.clickHeader}">
                ${this.label ? html ` <ep-label @click="${this.clickHeader}">${this.label}</ep-label>` : ''}
                <slot name="header">
                    <div class="value">${this.value ? this.value : ''}</div>
                </slot>
            </div>
            <div class="body">
                <slot name="body"></slot>
            </div>
        `;
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.slotBody.addEventListener('slotchange', this.slotChange);
        this.slotBodyItems = this.slotBody.assignedElements();
    }
    updated(_changedProperties) {
        var _a, _b;
        super.updated(_changedProperties);
        if (this.value && this.labelElement) {
            (_b = (_a = this.labelElement) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('value');
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.slotBodyItems) {
            this.slotBodyItems.forEach((item) => {
                item.removeEventListener('click', this.clickItem);
            });
        }
    }
}
Dropdown.styles = [dropDownDialogStyles, dropDownStyles];
if (!customElements.get('ep-dropdown')) {
    customElements.define('ep-dropdown', Dropdown);
}
//# sourceMappingURL=element.js.map